import FollowUpVKA from "../../../../src/components/content/FollowUpVKA";
import * as React from 'react';
export default {
  FollowUpVKA,
  React
};